import {Routes, Route} from "react-router-dom";
import Profile from "../../layout/product/profile/Profile";
import AddProfilePage from "../../layout/product/profile/AddProfile";
import PriceLayout from "../../layout/product/PriceLayout";
import {useEffect} from "react";

const ProfilePages = () => {
    useEffect(() => {
        return () => {
            localStorage.removeItem("selectedId");
            localStorage.removeItem("itemOffset");
            localStorage.removeItem("forcePage");
        };
    }, []);

    return (
        <>
            <Routes>
                <Route path="/" element={<Profile/>}/>
                <Route path="/add" element={<AddProfilePage/>}/>
                <Route path="/update/:id" element={<AddProfilePage/>}/>
                <Route path="/price/:id/:name" element={<PriceLayout/>}/>
            </Routes>
        </>
    );
};

export default ProfilePages;
